import ParticipantsAudioVolumeProvider from './ParticipantsAudioVolumeProvider';
import useParticipantAudioVolume from './useParticipantAudioVolume';

export default ParticipantsAudioVolumeProvider;
export { useParticipantAudioVolume };
